var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDependentFieldskeepStyle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.674 12.128H9.976a1.5 1.5 0 01-1.5-1.5V6.929a1.5 1.5 0 011.5-1.5h3.698a1.5 1.5 0 011.5 1.5v3.698a1.5 1.5 0 01-1.5 1.501zM13.674 24.308H9.976a1.5 1.5 0 01-1.5-1.5V19.11a1.5 1.5 0 011.5-1.5h3.698a1.5 1.5 0 011.5 1.5v3.698a1.5 1.5 0 01-1.5 1.5zM13.674 36.489H9.976a1.5 1.5 0 01-1.5-1.5V31.29a1.5 1.5 0 011.5-1.5h3.698a1.5 1.5 0 011.5 1.5v3.698a1.5 1.5 0 01-1.5 1.501zM21.751 9.086h13.5M21.826 21.1h13.35M21.751 33.113h13.5",
    fill: "none",
    stroke: "#4B4A5D",
    strokeWidth: 3.038,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDependentFieldskeepStyle);
export default __webpack_public_path__ + "static/media/dependentFields.keepStyle.42fd03cc08f17c8c3ecea8038cc8e124.svg";
export { ForwardRef as ReactComponent };